/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { getTranslationKey } from '../../modules/utils';

// Types
interface WhiteLabelInfo {
  companyUrl?: string;
  companyName?: string;
  imprintUrl?: string;
  privacyUrl?: string;
  type?: string;
  [key: string]: any;
}

interface StateProps {
  whiteLabel?: WhiteLabelInfo | null;
}

const DefaultFooter: React.FC<StateProps> = ({ whiteLabel }) =>
  whiteLabel ? (
    <span>
      <a target="_blank" href={whiteLabel.companyUrl} rel="noopener noreferrer">
        {whiteLabel.companyName}
      </a>{' '}
      &copy; {moment().year()}{' '}
      <a target="_blank" href={whiteLabel.imprintUrl} rel="noopener noreferrer">
        {getTranslationKey('imprint')}
      </a>
      {' | '}
      <a target="_blank" href={whiteLabel.privacyUrl} rel="noopener noreferrer">
        {getTranslationKey('privacy')}
      </a>
      {whiteLabel?.type === 'SB' && (
        <span>
          {' | '}
          <a
            onClick={() => window.Cookiebot && window.Cookiebot.show()}
            href="#"
            rel="noopener noreferrer"
          >
            {getTranslationKey('changeCookieConsent')}
          </a>
        </span>
      )}
      {whiteLabel?.type === 'SB' && (
        <span>
          {' | '}
          <a target="_blank" href="https://scrappbook.statuspage.io" rel="noopener noreferrer">
            Server Status
          </a>
        </span>
      )}
    </span>
  ) : null;

const mapStateToProps = ({ auth }: any): StateProps => ({
  whiteLabel: auth?.whiteLabel ?? null
});

export default connect<StateProps, unknown, unknown, any>(mapStateToProps, null)(DefaultFooter);
